import { render } from "./Autenticacoes.vue?vue&type=template&id=7ce964be&scoped=true"
import script from "./Autenticacoes.vue?vue&type=script&lang=js"
export * from "./Autenticacoes.vue?vue&type=script&lang=js"

import "./Autenticacoes.vue?vue&type=style&index=0&id=7ce964be&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ce964be"]])

export default __exports__